import orderingRoutes from './views/ordering/routes'

const routes = [...orderingRoutes]

export default routes
